import React, { useState } from 'react'
import { StyleSheet, Dimensions, TouchableOpacity, Linking, Text, View, Platform } from 'react-native'
import styles from './WebRedirectStyles'

export const WebRedirect = ({ downloadUrl, containerWidth, contentSeen }) => {
    const [error, setError] = useState(false)

    const handlePress = async () => {
        const supported = await Linking.canOpenURL(downloadUrl)

        if (supported) {
            await Linking.openURL(downloadUrl)
            // Si abrimos en nueva pestaña, consideramos el contenido como visto
            if (typeof contentSeen === 'function') {
                try {
                    contentSeen()
                } catch {}
            }
        } else {
            console.log(`Don't know how to open this URL: ${downloadUrl}`)
        }
    }

    // Para web, intentamos embeber el PDF
    if (Platform.OS === 'web') {
        const isPDF = downloadUrl?.toLowerCase().includes('.pdf')

        if (isPDF && !error) {
            const width = containerWidth || Dimensions.get('window').width
            const height = width * 1.4 // Aspect ratio típico de documentos

            return (
                <View style={[styles.container, { width, height }]}>
                    <iframe
                        src={downloadUrl}
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            borderRadius: 8,
                        }}
                        title='PDF Viewer'
                        onLoad={() => {
                            // Marcamos como visto apenas carga el PDF embebido
                            if (typeof contentSeen === 'function') {
                                try {
                                    contentSeen()
                                } catch {}
                            }
                        }}
                        onError={() => {
                            console.log('Error loading PDF iframe, showing button fallback')
                            setError(true)
                        }}
                    />
                </View>
            )
        }
    }

    // Fallback: botón para abrir en nueva pestaña
    return (
        <TouchableOpacity style={[styles.item, { aspectRatio: 1 }]} onPress={handlePress}>
            <Text style={styles.button}>Abrir Documento</Text>
        </TouchableOpacity>
    )
}
